import React, { createContext, useContext, ReactNode } from 'react';
import { useViewport } from '../hooks/useViewport';

interface ViewportContextType {
  width: number;
  height: number;
  viewportHeight: number;
  realVh: number;
  isKeyboardVisible: boolean;
  keyboardHeight: number;
}

const ViewportContext = createContext<ViewportContextType>({
  width: 0,
  height: 0,
  viewportHeight: 0,
  realVh: 0,
  isKeyboardVisible: false,
  keyboardHeight: 0,
});

export const useViewportContext = () => useContext(ViewportContext);

interface ViewportProviderProps {
  children: ReactNode;
}

export const ViewportProvider: React.FC<ViewportProviderProps> = ({ children }) => {
  const viewport = useViewport();
  return (
    <ViewportContext.Provider value={viewport}>
      {children}
    </ViewportContext.Provider>
  );
};
